import { platformIntro } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string; border: string; hover: string }> = {
  primary: {
    bg: 'bg-primary-50',
    text: 'text-primary-600',
    border: 'border-primary-200',
    hover: 'hover:border-primary-300 hover:bg-primary-50/70',
  },
  accent: {
    bg: 'bg-accent-50',
    text: 'text-accent-600',
    border: 'border-accent-200',
    hover: 'hover:border-accent-300 hover:bg-accent-50/70',
  },
  secondary: {
    bg: 'bg-secondary-50',
    text: 'text-secondary-600',
    border: 'border-secondary-200',
    hover: 'hover:border-secondary-300 hover:bg-secondary-50/70',
  },
};

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function PlatformIntro() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            合作平台介绍
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            与多家优质视频平台深度合作，为您聚合最丰富的影视资源
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {platformIntro.map((platform) => {
            const colors = colorMap[platform.color];
            const tagColors = tagColorMap[platform.color];

            return (
              <div
                key={platform.name}
                className={`group rounded-2xl border ${colors.border} ${colors.hover} bg-background-50 p-6 md:p-8 cursor-pointer transition-all duration-300 hover:-translate-y-1`}
              >
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl ${colors.bg} ${colors.text} mb-5`}>
                  <i className={`${platform.icon} text-2xl`}></i>
                </div>

                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-3">
                  {platform.name}
                </h3>

                <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                  {platform.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {platform.features.map((feature) => (
                    <span
                      key={feature}
                      className={`px-3 py-1 rounded-full text-xs font-medium ${tagColors}`}
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}